/* eslint-disable max-len */
/* eslint-disable class-methods-use-this */
import React from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
// template components
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
// shared components
import EquityStyleBoxTable from '../_components/equityStyleBoxTable';
import FixedIncomeStyleBoxTable from '../_components/fixedIncomeStyleBoxTable';
import RelatedLinksSection from '../_components/relatedLinksSection';
import SpecialtyAndHybridFundsTable from '../_components/specialtyAndHybridFundsTable';
// native components
import IntroSection from './components/introSection';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps } = useRouteData();

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      dynamicConfig={dynamicConfig}
      config={config}
      breadcrumbsNavigationConfig={[
        {
          pageName: 'Home',
          linkUrl: '/',
          linkAriaLabel: 'Northwestern Mutual Home',
        },
        {
          pageName: 'Fixed Variable Annuities',
          linkUrl: '/investments/fixed-annuity-vs-variable-annuity/',
          linkAriaLabel: 'Northwestern Mutual Fixed Variable Annuities',
        },
        {
          pageName: 'Underlying Fund Information',
          linkUrl: '/fixed-annuity-vs-variable-annuity/underlying-fund-information',
          linkAriaLabel: 'Northwestern Mutual Underlying Fund Information',
        },
      ]}
      customDisclaimers={[
        <>
          You could lose money by investing in the Government Money Market Portfolio. Although the Portfolio seeks to preserve the value of your investment at &#36;1.00 per share, it cannot guarantee it will do so. An investment in the Portfolio is not insured or guaranteed by the Federal Deposit Insurance Corporation or any other government agency. The Portfolio&#39;s sponsor has no legal obligation to provide financial support to the Portfolio, and you should not expect that the sponsor will provide financial support to the Portfolio at any time.
        </>,
        <>
          Mason Street Advisors, LLC &#40;MSA&#41; is a wholly owned company of Northwestern Mutual and is a federally registered investment advisor.
        </>,
        <>
          Mason Street Advisors, LLC &#40;MSA&#41;, a wholly owned company of Northwestern Mutual, is a federally registered investment adviser. MSA is the principal investment adviser for all the Portfolios in the Northwestern Mutual Series Fund &#40;Series Fund&#41;. &#40;Portfolios in the Series Funds are identified by the parenthetical next to the portfolio name.&#41; MSA has engaged and oversees subadvisers who provide day&#45;to&#45;day management for certain of the Series Fund Portfolios. Each subadviser may be replaced without the approval of shareholders. Please see the prospectus for more information. Additional fund options are advised by Russell Investments, Fidelity&#174; Investments, UBS Asset Management (Americas) LLC, and Neuberger Berman Investment Advisers LLC.
        </>,
        <>
          NMFN&#8211;FUNDS &#40;1012&#41;
        </>,
      ]}>

      <IntroSection />

      <EquityStyleBoxTable
        sectionIdAmmendment='annuities'
        customIntroText='the Select Variable Annuity' />

      <SpecialtyAndHybridFundsTable sectionIdAmmendment='annuities' />

      <FixedIncomeStyleBoxTable sectionIdAmmendment='annuities' />

      <RelatedLinksSection />

    </Page>
  );
};
